/** Shared class names for the booking table's header cells and inline links.
 *  Their own module now that the header and the row are separate components. */
export const TH =
  'px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-stone-500';
export const LINK = 'hover:text-moss-600 hover:underline dark:hover:text-moss-400';
